import React, { Component } from 'react';
import { connectDynamic } from 'go/components/dynamic/dynamicComponent';
import { InView } from 'react-intersection-observer';
import { connect } from 'react-redux';
import _ from 'lodash';


export class SectionViewObserver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inView: false,
    };
  }

  render() {
    return (
      <InView as="div" onChange={(inView, entry) => this.markPropertyAsReviewed(inView)}>
        <React.Fragment />
      </InView>
    );
  }

  markPropertyAsReviewed = (inView) => {
    const { propsReviewed, entityType, data } = this.props;
    if (inView === true) {
      const saveReview = _.get(data, `payload.${propsReviewed}.needsAttention`, undefined);
      if (!saveReview !== false) {
        this.props.saveEntityData(
          `${this.props.pathToBeUsed}.payload.${propsReviewed}.needsAttention`,
          entityType,
          false
       );
      }
    }
  };
}

export const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(
  mapStateToProps
)(connectDynamic(SectionViewObserver));
